// Oznámení o výpadku 9.–12. 10. 2026 (Google podruhé pozastavil projekt). Vyskočí
// každému jednou; po zavření si to pamatuje prohlížeč. Od OUTAGE_NOTICE_UNTIL se
// neukáže nikomu — a pak se tenhle soubor i s klíči `outage.*` v locales smaže.
// Stejná komponenta jako po výpadku 1.–2. 10. (a0be52e), jen nový klíč a texty.
//
// Jen tam, kde existuje text (`outage.title`): pl/hr/de ho nemají a jedou starou
// verzi, takže se jim neukáže.
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const OUTAGE_NOTICE_KEY = "outageNotice-2026-10-09";
export const OUTAGE_NOTICE_UNTIL = "2026-10-15"; // první den, kdy se už neukáže

const POLOZKY = ["what", "why", "compensation", "streak", "data", "duration"];

function todayIso() {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

function uzZavreno() {
  try {
    return !!localStorage.getItem(OUTAGE_NOTICE_KEY);
  } catch {
    return false;
  }
}

export default function OutageNotice() {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(
    () => i18n.exists("outage.title") && todayIso() < OUTAGE_NOTICE_UNTIL && !uzZavreno(),
  );
  if (!open) return null;

  const zavrit = () => {
    try {
      localStorage.setItem(OUTAGE_NOTICE_KEY, "1");
    } catch {
      // Soukromé okno / zablokované úložiště: zavře se aspoň teď.
    }
    setOpen(false);
  };
  const prepnout = (e) => {
    e.currentTarget.classList.toggle("active");
    e.currentTarget.nextElementSibling.classList.toggle("open");
  };

  return (
    <div
      className="modal"
      onClick={(e) => {
        if (e.target.classList.contains("modal")) zavrit();
      }}
    >
      <div className="modal-content social-modal outage-notice" role="dialog" aria-modal="true"
        aria-labelledby="outage-notice-title">
        <div className="modal-header">
          <h2 id="outage-notice-title" style={{ textTransform: "none" }}>{t("outage.title")}</h2>
          <button type="button" className="close" aria-label={t("outage.close")} onClick={zavrit}>
            &times;
          </button>
        </div>
        {/* Posouvá se jen tohle; tlačítko pod tím zůstává vždy vidět. */}
        <div className="outage-notice__body">
          <p className="outage-notice__lead">{t("outage.lead")}</p>
          {POLOZKY.map((k) => (
            <div className="faq-collapsible" key={k}>
              <h3 className="faq-title" onClick={prepnout}>{t(`outage.${k}.title`)}</h3>
              <div className="faq-content">
                <p>{t(`outage.${k}.content`)}</p>
              </div>
            </div>
          ))}
        </div>
        <button type="button" className="outage-notice__ok" onClick={zavrit}>
          {t("outage.ok")}
        </button>
      </div>
    </div>
  );
}
